import React, { useState, useEffect, Fragment } from "react";
// import { useStateWithCallbackLazy } from "use-state-with-callback";
import { useHistory, useLocation } from "react-router-dom";
import {
    Col,
    Form,
    Container,
    Row,
    Modal,
    Image,
    Button,
} from "react-bootstrap";
import { TextField, FormControl, Select } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
//import { PaymentSuccessModel } from "../../Orders/OrderRequest/RightComponentOrderRequest";
import moment from "moment";
import Alert from "react-s-alert";
import { EVENT_RAZORPAY_KEY, ORDER_RAZORPAY_KEY } from "../../../../../config/Keys";

// import { connect } from "react-redux";
// import { withRouter } from "react-router-dom";
// import { useFormik } from "formik";
import * as yup from "yup";

// import PropTypes from "prop-types";
// import { connect } from "react-redux";
// import { withRouter } from "react-router-dom";
// import isEmpty from "../../../../store/validation/is-Empty";
// import { add_rsvp_events } from "../../../../store/actions/RsvpEventDashboard/RsvpEventDashboardAction";
import {
    editTransaction,
    razor_pay_create_order,
    razor_payment,
} from "../../../../../store/actions/OrderingAction/vendorOrderingAction";
// import { rsvp_edit_perticular_event_request } from "../../../../store/actions/RsvpEventDashboard/RsvpEventDashboardAction";
// //import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
// import { TRANSACTION_ID } from "../../../../store/types";
// import store from "../../../../store/store";
import CashModal from "../../../../reusableComponents/CashModalComponent";
import { amApi } from "../../../../../api/apiHelper";
import { useDispatch, useSelector } from "react-redux";
import { errorAlert, successAlert } from "../../../../../function/alert";
import ExpCashModal from "../../../../reusableComponents/ExpCashModalComponent";
import ExpPaymentSuccessModel from "../../../../reusableComponents/ExpPaymentModal";
import { splitTaxesExperience } from "../../../../../function/expMethods";
import InfoToolTip from "../../../../reusableComponents/InfoTooltipComponent";

//custom Hook


const PaymentExperience = ({ formik, experience, onCancel, backPage, reqId, ...props }) => {
    let history = useHistory();
    const dispatch = useDispatch();

    const auth = useSelector((state) => state.auth.user?.accessToken || '');

    const [open, setOpen] = useState(false);
    const [displayCustomInput, setDisplayCustomInput] = useState(false);
    const [selectedValue, setSelectedValue] = React.useState("");
    const [getSingleEventInfo, setGetSingleEventInfo] = useState({});
    const [paymentModal, setPaymentModal] = useState({ show: false, status: false, requestData: {} });

    const [disabled, setDisabled] = useState(false);

    const [state, setState] = useState({
        code: "",
        emailChecked: false,
        donates: [
            { id: 0, title: "No", value: 0 },
            { id: 1, title: "₹ 10", value: 10 },
            { id: 2, title: "₹ 50", value: 50 },
            { id: 3, title: "₹ 100", value: 100 },
        ],
        donationAmount: 0,
        transactionalId: 0,
        allFormData: {},
        expId: 0,
        payment_pending: false,
    });

    const [onlinePayment, setOnlinePayment] = useState(true);

    const [showCancel, setShowCancel] = useState(false);
    const [showCashModal, setShowCashModal] = useState(false);
    const [amount, setAmount] = useState(0);

    const [externalRef, setExternalRef] = useState("");

    const submitExternal = (data) => {
        setExternalRef(data);
        setShowCancel(false);
    };

    const loadScript = (src) => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    };

    const onCheckboxHandle = () => {
        setState({
            ...state,
            emailChecked: !state.emailChecked,
        });
    };

    useEffect(() => {
        let newAmount = (formik.values.adultCount * formik.values.adultPrice) + (formik.values.kidsCount * formik.values.kidsPrice) + (formik.values.package.count * formik.values.package.price)
        let taxData = splitTaxesExperience(newAmount, reqId ? experience?.experienceId : experience);
        formik.setFieldValue('taxes', taxData.taxes);
        formik.setFieldValue('taxesTotal', taxData.taxesTotal);
        formik.setFieldValue('surCharges', taxData.surCharges);
        formik.setFieldValue('surChargesTotal', taxData.surChargesTotal);
        setAmount(newAmount + formik.values.paymentData.donationAmount);
        formik.setFieldValue('paymentData.amount', newAmount);
        formik.setFieldValue('paymentData.totalAmount', newAmount + formik.values.paymentData.donationAmount + taxData.taxesTotal + taxData.surChargesTotal);
    }, [formik.values.paymentData.donationAmount, reqId])



    async function displayRazorpay(
        donationAmount,
        total,
        userId,
        name,
        phoneNo,
        email,
        expId,
        handlerId,
        onError
    ) {
        const res = await loadScript(
            "https://checkout.razorpay.com/v1/checkout.js"
        );
        if (!res) {
            alert("Razorpay SDK failed to load. Are you online?");
            return;
        }
        const onSuccess = (data) => {
            setState({
                ...state,
                transactionalId: data.transactional._id,
                expId: expId,
            });
            const onSuccessHandler = (response, data) => {
                const formData = {
                    razorpay_payment_id: response.razorpay_payment_id,
                    transactional_id: data.transactional._id,
                    status: "PENDING",
                    isEvent: false,
                    transaction_type: "RAZORPAY",
                    currency: "INR",
                    user_id: userId,
                    restaurant_id: formik.values.restaurantId,
                    expRequestId: handlerId,
                };
                if (donationAmount) {
                    formData.donation = {};
                    formData.donation.amount = donationAmount;
                }
                dispatch(razor_payment(
                    auth,
                    formData,
                    onSuccessCallFinalApi,
                    handlerId,
                    onError
                ))
            };

            const onFailure = (response) => {
                const formData = {};
                formData.payment_status = 3;
                formData.event_status = "PENDING";
                formData.transactional_id = data.transactional._id;
                formData.razorpay_payment_id = response.error.metadata.payment_id;
                const token = props.auth.user.accessToken;
                setPaymentModal({ show: true, status: false })
                // rsvp_edit_perticular_event_request(formData, handlerId, token)
            };

            const options = {
                key: ORDER_RAZORPAY_KEY,
                currency: data.currency,
                amount: data.amount.toString(),
                donation: {
                    amount: data && data.donation && data.donation.amount.toString(),
                },
                order_id: data.id,
                name: "Amealio",
                description: "Amealio Ordering Payment",
                method: {
                    netbanking: false,
                    card: true,
                    wallet: false,
                    upi: false,
                },
                handler: function (response) {
                    onSuccessHandler(response, data);
                },
                prefill: {
                    name: name,
                    email: email,
                    contact: phoneNo,
                },
            };
            const paymentObject = new window.Razorpay(options);
            paymentObject.open();
            paymentObject.on("payment.failed", function (response) {
                onFailure(response);
            });
        };

        const formData = {
            amount: parseFloat(total).toFixed(2),
            donation: {
                amount: parseFloat(donationAmount),
            },
            user_id: userId,
            refModel: "User",
            message: "Experience",
            currency: "INR",
            isEvent: false, // TODO Based on Experience 
            receipt: handlerId,
            expRequestId: handlerId
        };
        dispatch(razor_pay_create_order(auth, formData, onSuccess, expId));
    }

    const onSuccessCallFinalApi = async (data, handlerId, onError) => {
        let formData = {};
        if (data) { formData.transactionalId = [data._id]; }
        formData.paymentStatus = 1;
        formData.status = "PENDING";
        if(reqId){
            formData = {
                "paymentData": {
                    ...formik.values.paymentData,
                    "paymentMethod": selectedValue,
                    "totalAmount": formik.values.paymentData.totalAmount, 
                    "amount": formik.values.paymentData.totalAmount,
                },
                "paymentStatus": 1,
                "paynow": true
            }
            amApi.patch(`/userExpRequest/${handlerId}`, formData).then(data => {
             
                    let transactionData = {
                        "id": reqId,
                        "paid": true,
                        "method": "EXTERNAL",
                        "amount": formik.values.paymentData.totalAmount,
                        "type": "PAYMENT",
                        "date": Date.now(),
                        "paymentType": selectedValue,
                        "experience": true
                    };
                    dispatch(editTransaction(transactionData));
                    onSuccessPayment(data.data)
            }).catch(err => {
                onError(err);
                errorAlert('Something went wrong try again')
            })
        } else {
            amApi.patch(`/expRequest/${handlerId}`, formData).then(data => {
                onSuccessPayment(data.data)
                
            }).catch(err => {
                onError(err);
                errorAlert('Something went wrong try again')
            })
        }
    };

    const onSuccessPayment = (data) => {
        setPaymentModal({ status: true, show: true, requestData: data });
    };

    const onPaymentDone = () => {
        if (paymentModal.status) {
            history.push({
                pathname: `${experience?.expType === 'SPECIAL' ? `/specialDashboard/${reqId ? experience?.experienceId?._id : experience?._id}/pending` : `/curatedDashboard/${reqId ? experience?.experienceId?._id : experience?._id}/pending`}`
            });
            setPaymentModal({ show: false, status: false });
        } else {
            setPaymentModal({ show: false, status: false });
        }
    }

    const [successPayment, setSuccessPayment] = useState({});
    const [expRequest, setExpRequest] = useState({});

    const [count, setCount] = useState(1);

    const onClickSave = async () => {
        try {
            if (selectedValue === 8 && !externalRef) {
                Alert.error("<h4>Please Enter Reference Data</h4>", {
                    position: "top-right",
                    effect: "bouncyflip",
                    beep: true,
                    html: true,
                    timeout: 3000,
                    offset: 35,
                });
            } else {
                setDisabled(true)
                setCount(count + 1);
                let formData = { ...formik.values };
                if(reqId){
                    if ([1, 2, 3, 4, 5].includes(selectedValue)) {
                        displayRazorpay(
                            formik.values.paymentData.donationAmount,
                            formik.values.paymentData.donationAmount + amount,
                            formData.userId,
                            formik.values.userDetails.name,
                            formik.values.userDetails.mobileNumber,
                            formik.values.userDetails.email,
                            experience._id,
                            formData._id
                        )
                    } else {
                        onSuccessCallFinalApi(null, formData._id, () => setDisabled(false));
                    }
                }else{
                    formData.status = 'INITIAL';
                    let request = await amApi.post('/expRequest', formData);
                    setExpRequest(request.data)
                    if (request.status === 201) {
                        if ([1, 2, 3, 4, 5].includes(request.data.paymentData.paymentMethod)) {
                            displayRazorpay(
                                formik.values.paymentData.donationAmount,
                                formik.values.paymentData.donationAmount + amount,
                                request.data.userId,
                                formik.values.name,
                                formik.values.userDetails.mobileNumber,
                                formik.values.userDetails.email,
                                experience._id,
                                request.data._id
                            )
                        } else {
                            onSuccessCallFinalApi(null, request.data._id, () => setDisabled(false));
                        }
                    }
                }
            }
        } catch (err) {
            errorAlert(err?.request?.data?.message || err || 'Something went wrong, try again later')
        }
    };

    const onCustomButton = () => {
        setDisplayCustomInput(!displayCustomInput);
    };



    const selectPayment = (id) => {
        if (id === 8) {
            setShowCancel(true);
        } else if (id === 9) {
            setShowCashModal(true);
        }
        setSelectedValue(id);
        formik.setFieldValue('paymentData.paymentMethod', id);
    };

    console.log('formik.values', formik.values)
    return (
        <React.Fragment>
            <Row>
                <Col md={8}>
                    <MuiThemeProvider theme={theme}>
                        <Container fluid>
                            <h3 className="py-3">Payment</h3>
                            <div style={{ paddingTop: "2%" }}>
                                <Row>
                                    <Col md={8}>
                                        <Form.Group>
                                            <TextField
                                                id="name"
                                                label="Name"
                                                type="text"
                                                variant="outlined"
                                                value={formik.values.userDetails?.name}
                                                fullWidth
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={2} sm={2} md={2} lg={2} xl={2}>
                                        <Form.Group>
                                            <TextField
                                                id="code"
                                                label="Code"
                                                type="text"
                                                variant="outlined"
                                                value={formik.values.userDetails?.countryCode}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={8}>
                                        <Form.Group>
                                            <TextField
                                                id="mobile_number"
                                                label="Phone Number"
                                                type="number"
                                                variant="outlined"
                                                value={formik.values.userDetails?.mobileNumber}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <br />
                                {/* <div className="row">
                                    <Col md={5}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={state.emailChecked}
                                                    color="primary"
                                                    onChange={(e) => onCheckboxHandle(e)}
                                                    name="emailChecked"
                                                    id="emailChecked"
                                                />
                                            }
                                            label="Would you like to get receipt in email?"
                                        />
                                    </Col>
                                    {state.emailChecked ? (
                                        <Col md={5}>
                                            <Form.Group>
                                                <TextField
                                                    id="email"
                                                    label="E-mail Address"
                                                    type="text"
                                                    variant="outlined"
                                                    value={formik.values.userDetails?.email}
                                                />
                                            </Form.Group>
                                        </Col>
                                    ) : null}
                                </div> */}
                                <hr />
                                <Container fluid>
                                    <Row>
                                        <div className="f16-500 mb-2">
                                            {experience?.name || experience?.experienceId?.name}
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className="f12-400" style={{ color: "#EE3A23" }}>
                                            Experience ID: {experience?.expId || experience?.experienceId?.expId}
                                        </div>
                                    </Row>
                                    <br />
                                    <Row style={{ backgroundColor: "#ffffff", padding: "15px" }}>
                                        <Col md={3}>
                                            <b>
                                                {moment(formik.values.reservationDate).format(
                                                    "Do MMM YYYY"
                                                )}
                                            </b>
                                            <br />
                                            <span style={{ color: "#757575" }}>Start Date</span>
                                        </Col>
                                        <Col md={3}>
                                            <b>
                                            {moment(formik.values.reservationDate).format(
                                                    "HH:MM A"
                                                )}
                                            </b>
                                            <br />
                                            <span style={{ color: "#757575" }}>Time</span>
                                        </Col>

                                        <Col md={3}>
                                            <b>
                                                {formik.values.kidsCount + formik.values.adultCount + formik.values.package.adults + formik.values.package.kids}
                                            </b>
                                            <br />
                                            <span style={{ color: "#757575" }}> Tickets</span>
                                        </Col>
                                    </Row>
                                    <Row className="p-3" style={{ backgroundColor: "#FFF3CF" }}>
                                        <Col md={10} className="d-flex justify-content-between">
                                            <div className="f14-700">
                                                {formik.values.adultCount + formik.values.package.adults} Adults | {formik.values.kidsCount + formik.values.package.kids} Kids
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row
                                        style={{
                                            backgroundColor: "#FFFBEE",
                                            padding: "15px",
                                            display: "flex",
                                            alignItems: "center",
                                        }}
                                        className="d-flex justify-content-between align-middle"
                                    >
                                        <Col md={10} className="d-flex">
                                            <p className="f18-700 mr-2">
                                                ₹ {formik.values.paymentData?.totalAmount}
                                            </p><p style={{ color: "#212121" }}>Total Amount To Be Paid</p>

                                        </Col>
                                        <Col md={2}></Col>
                                    </Row>
                                    <hr />
                                    <h5>Select payment method</h5>
                                    <br />
                                    {paymentData.map((data, index) => {
                                        return (
                                            <Fragment key={index}>
                                                {data.show ? (
                                                    <PaymentsInfo
                                                        data={data}
                                                        selectedValue={selectedValue}
                                                        handlePaymentType={selectPayment}
                                                    />
                                                ) : (
                                                    <Fragment></Fragment>
                                                )}
                                            </Fragment>
                                        );
                                    })}
                                </Container>
                            </div>
                        </Container>
                    </MuiThemeProvider>
                </Col>
                <Col md={4} style={{ backgroundColor: "#ffffff" }}>
                    <Container className="mt-4">
                        <Row>
                            <Col xs={10}>
                                <div className="f16-500">Customer Details </div>
                            </Col>
                            <Col xs={2}>
                                <div className="f16-500" style={{ color: "#EE3A23", cursor: "pointer" }} onClick={() => backPage()}>Edit </div>
                            </Col>
                        </Row>
                        <div className="row mb-3 mt-3 align-items-center">
                            <div className="col-1">
                                <div
                                    style={{
                                        borderRadius: "50px",
                                        width: "30px",
                                        height: "30px",
                                        textAlign: "center",
                                        border: "1px solid black"
                                    }}
                                >
                                    <img
                                        src={require("../../../../../assets/images/superadmin/ordericon/1-03.svg")}
                                        className="img-fluid"
                                        style={{ width: "50%" }}
                                        alt="Customer Name"
                                        title="Customer Name"
                                    />
                                </div>
                            </div>
                            <div className="col-7">
                                <div className="f16-500">
                                    {formik.values.userDetails.name}
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3 align-items-center">
                            <div className="col-1">
                                <div
                                    style={{
                                        borderRadius: "50px",
                                        width: "30px",
                                        height: "30px",
                                        textAlign: "center",
                                        border: "1px solid black"
                                    }}
                                >
                                    <img
                                        src={require("../../../../../assets/images/superadmin/ordericon/1-02.svg")}
                                        className="img-fluid"
                                        style={{ width: "50%" }}
                                        alt="Customer Name"
                                        title="Customer Name"
                                    />
                                </div>
                            </div>
                            <div className="col-7">
                                <div className="f16-500">
                                    {formik.values.userDetails.mobileNumber}
                                </div>
                            </div>
                        </div>

                        <Container
                            fluid
                            className="mt-4 pt-4 pb-4"
                            style={{ backgroundColor: "#FFFBEE" }}
                        >
                            <Row>
                                <Col xs={8}>
                                    {" "}
                                    <h4>Want to Donate to Smiles?</h4>
                                </Col>
                                <Col
                                    xs={4}
                                    className="f10-700"
                                    style={{ color: "#2196F3", cursor: "pointer" }}
                                >
                                    Learn More
                                </Col>
                            </Row>
                            <Row
                                style={{ marginLeft: "3%" }}
                                className="superadmin-orderscomponent-main"
                            >
                                {state.donates.map((data) => {
                                    return (
                                        <Col
                                            xs={3}
                                            sm={3}
                                            md={3}
                                            className="p-0 mt-3 mr-2"
                                            align="center"
                                            onClick={() => formik.setFieldValue('paymentData.donationAmount', data.value)}
                                            key={data.id}
                                        >
                                            <div
                                                className={`f12-400 take-away-order-select 
                                   ${formik.values?.paymentData.donationAmount === data.value &&
                                                    `take-away-order-select-selected`
                                                    }
                                `}
                                                style={{
                                                    padding: "10px",
                                                    marginRight: "1%",
                                                    marginBottom: "1%",
                                                }}
                                            >
                                                {data.title}
                                            </div>
                                        </Col>
                                    );
                                })}
                                {displayCustomInput ? (
                                    <div className="row mt-3">
                                        <Col md={4}>
                                            <TextField
                                                id="donate_amount"
                                                label="Amount"
                                                type="number"
                                                variant="outlined"
                                                onInput={(e) => {
                                                    e.target.value = Math.max(0, parseInt(e.target.value))
                                                        .toString()
                                                        .slice(0, 10);
                                                }}
                                                name="donation"
                                                onChange={formik.handleChange}
                                                value={formik.values.paymentData.donation}
                                                onBlur={formik.handleBlur}
                                            />
                                        </Col>
                                        <Col md-5>
                                            <button
                                                className="pl-3 pr-3"
                                                style={{
                                                    boxShadow: "0px 5px 8px #6E6E6E57",
                                                    borderRadius: "15px",
                                                    backgroundColor: "#2196F3",
                                                    color: "#ffffff",
                                                    border: "none",
                                                }}
                                                onClick={() => formik.setFieldValue('paymentData.donationAmount', formik.values.donation)}
                                            >
                                                Add
                                            </button>
                                        </Col>
                                    </div>
                                ) : (
                                    <Col
                                        xs={3}
                                        sm={3}
                                        md={3}
                                        className="p-0 mt-3 mr-2"
                                        align="center"
                                        onClick={onCustomButton}
                                    >
                                        <div
                                            className={"f12-400 take-away-order-select"}
                                            style={{
                                                padding: "10px",
                                                marginRight: "1%",
                                                marginBottom: "1%",
                                            }}
                                        >
                                            Custom
                                        </div>
                                    </Col>
                                )}
                            </Row>
                        </Container>
                        <div className="mt-3 mb-3">
                            <h4 className="f16-700">Order Summary</h4>
                        </div>
                        <Row className="mt-2">
                            <Col>
                                <div className="f12-400">Sub Total</div>
                            </Col>
                            <Col align="right">
                                <div className="f12-400">
                                    ₹ {amount - formik.values.paymentData.donationAmount}
                                </div>
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col>
                                <div className="f12-400 d-flex align-items-center">
                                    Taxes
                                    {formik?.values?.taxesTotal ?
                                        <InfoToolTip
                                            title={"Taxes"}
                                            hover={true}
                                            data={formik?.values?.taxes || {}}
                                        /> : <></>
                                    }
                                </div>
                            </Col>
                            <Col align="right">
                                {formik?.values?.taxesTotal > 0 ? (
                                    <div className="f12-400">
                                        ₹{parseFloat(formik?.values?.taxesTotal).toFixed(2)}
                                    </div>
                                ) : (
                                    <div className="f12-400"> ₹0</div>
                                )}
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col>
                                <div className="f12-400 d-flex align-items-center">
                                    Charges
                                    {formik?.values?.surChargesTotal ?
                                        <InfoToolTip
                                            title={"Sur Charges"}
                                            hover={true}
                                            data={formik?.values?.surCharges || {}}
                                        /> : <></>
                                    }
                                </div>
                            </Col>
                            <Col align="right">
                                {formik?.values?.surChargesTotal > 0 ? (
                                    <div className="f12-400">
                                        ₹{parseFloat(formik?.values?.surChargesTotal).toFixed(2)}
                                    </div>
                                ) : (
                                    <div className="f12-400"> ₹0</div>
                                )}
                            </Col>
                        </Row>
                        <hr />
                        <Row className="mt-2">
                            <Col>
                                <div className="f12-400">Donate Amount</div>
                            </Col>
                            <Col align="right">
                                <div className="f12-400">₹{formik.values.paymentData?.donationAmount}</div>
                            </Col>
                        </Row>
                    </Container>
                    <div className="mt-2 pt-2 pb-2" style={{ backgroundColor: "#F8F8F8" }}>
                        <Container>
                            <Row>
                                <Col md={6}>
                                    <div className="f14-700">To Pay</div>
                                </Col>
                                <Col md={6} align="right">
                                    <div className="f14-700">
                                        ₹ {formik.values.paymentData.totalAmount}
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>

                    {selectedValue === "0" ? (
                        <div className="mt-2 pt-2">
                            <Container>
                                <Row>
                                    <Col
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        className="d-flex justify-content-between align-self-center py-3"
                                    >
                                        <div className="col-4 f14-700 p-0">Cash Amount</div>
                                        <div className="col-5 p-0">
                                            <TextField
                                                id="cash_amount"
                                                label="Enter Cash Amount"
                                                type="number"
                                                variant="outlined"
                                                onInput={(e) => {
                                                    e.target.value = Math.max(0, parseInt(e.target.value))
                                                        .toString()
                                                        .slice(0, 10);
                                                }}
                                                name="cash_amount"
                                            // onChange={formik.handleChange}
                                            // value={formik.values.cash_amount}
                                            // onBlur={formik.handleBlur}
                                            />
                                        </div>
                                    </Col>
                                    <Col
                                        sm={12}
                                        md={12}
                                        lg={12}
                                        className="py-3 d-flex justify-content-between"
                                        style={{ backgroundColor: "#F3F3F3" }}
                                    >
                                        <span className="f14-500">
                                            {/* {formik.values.cash_amount < totalPeoplePrice
                      ? "Not Return Any Amount"
                      : " */}
                                            Balance to Return :{/* "} */}
                                        </span>
                                        <span
                                            className="f14-700"
                                            style={{
                                                color:
                                                    // formik.values.cash_amount < totalPeoplePrice
                                                    // ? "#212121":
                                                    "#EE3A23",
                                            }}
                                        >
                                            {/* {formik.values.cash_amount === ""
                                            ? ""
                                            : formik.values.cash_amount < totalPeoplePrice
                                                ? ""
                                                : `₹${Math.abs(cashAmountBalance)}`} */}
                                        </span>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    ) : (
                        ""
                    )}

                    <div className="row py-3 px-3 mt-3 justify-content-center border">
                        <div className="col-6">
                            <button
                                type="button"
                                className="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                                title="Cancel Button"
                                onClick={onCancel}
                            >
                                Cancel
                            </button>
                        </div>
                        <div className="col-6">
                            <button
                                type="button"
                                className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                                title="Save Button"
                                disabled={selectedValue === "" || disabled ? true : false}
                                // onClick={() => {
                                //   setOpen(true);
                                // }}
                                onClick={() => onClickSave()}
                            >
                                Proceed
                            </button>
                        </div>
                        {showCancel && (
                            <ExternalReference
                                hideCancel={() => setShowCancel(false)}
                                submitExternal={submitExternal}
                            />
                        )}
                        {showCashModal && (
                            <ExpCashModal
                                hideModal={(e) => {
                                    if (e) setSelectedValue("")
                                    setShowCashModal(false)
                                }}
                                formik={formik}
                                experience={experience}
                            />
                        )}
                        {paymentModal.show && (<ExpPaymentSuccessModel open={paymentModal.show} requestData={paymentModal?.requestData} success={paymentModal.status} experience={experience} request={formik.values} onPaymentDone={onPaymentDone} />)}
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    );
};


export default PaymentExperience;

const theme = createTheme({
    palette: {
        primary: { main: "#EE3A23" }, // Purple and green play nicely together.
        secondary: { main: "#9E9E9E" }, // This is just green.A700 as hex.
    },
});

const PaymentsInfo = (props) => {
    const [data, setData] = React.useState(props.data);
    const [view, setView] = React.useState(false);
    return (
        <div>
            <Row style={{ backgroundColor: "#ffffff", padding: "15px" }}>
                <Col xs={2}>
                    <Radio
                        checked={data.id === props.selectedValue ? true : false}
                        onChange={() => {
                            setView(true);
                            props.handlePaymentType(data.id);
                        }}
                        value={data.id}
                        name="radio-button-demo"
                        color="primary"
                        inputProps={{ "aria-label": data.id }}
                    />
                </Col>
                <Col xs={2}>
                    <img src={data.icon} alt="Icon pic" />
                </Col>
                <Col xs={8}>
                    <b>{data.title}</b>
                </Col>
            </Row>
            {data.value === "2" && props.selectedValue === "2" && (
                <Container style={{ padding: "20px" }}>
                    <h5>Send a Request to</h5>
                    <br />
                    <b>Enter Mobile Number</b>
                    <br />
                    <PhoneComponent />
                    <div class="mt-3 d-flex">
                        <button
                            type="button"
                            class="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                            title="Cancel Button"
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                            title="Save Button"
                        >
                            Send Link
                        </button>
                    </div>
                </Container>
            )}
        </div>
    );
};

export const PhoneComponent = (props) => {
    return (
        <Row>
            <Col xs={12} md={8}>
                <Row>
                    <Col xs={4} className="pr-0">
                        <Form.Group controlId={"country_code"}>
                            <FormControl variant="outlined" className="w-100">
                                <Select
                                    disabled
                                    value={+91}
                                    // onChange={handleChangeCode}
                                    inputProps={{
                                        name: "code",
                                    }}
                                    IconComponent={KeyboardArrowDownIcon}
                                >
                                    <option value={+91}>{props.country_code}</option>
                                </Select>
                            </FormControl>
                        </Form.Group>
                    </Col>
                    <Col xs={8}>
                        <Form.Group>
                            <TextField
                                disabled
                                id="outlined-basic"
                                label="Phone Number"
                                variant="outlined"
                                className="w-100"
                                value={props.mobile_number}
                            />
                        </Form.Group>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

const paymentData = [
    {
        id: 9,
        title: "Cash",
        value: "Cash",
        icon: require("../../../../../assets/images/superadmin/ordericon/credit-card (1).svg"),
        show: true,
    },
    {
        id: 8,
        title: "External Wallet",
        value: "Wallet",
        icon: require("../../../../../assets/images/superadmin/ordericon/credit-card (1).svg"),
        show: true,
    },
    {
        id: 1,
        title: "BHIM UPI",
        value: "BHIM UPI",
        icon: require("../../../../../assets/images/Orders/sdmlM4R-_400x400.png"),
        show: false,
    },
    {
        id: 2,
        title: "PayTM",
        value: "PayTM",
        icon: require("../../../../../assets/images/superadmin/ordericon/credit-card (1).svg"),
        show: false,
    },
    {
        id: 3,
        title: "Debit Card",
        value: "Debit Card",
        icon: require("../../../../../assets/images/superadmin/ordericon/credit-card (1).svg"),
        show: true,
    },
    {
        id: 4,
        title: "Credit Card",
        value: "Credit Card",
        icon: require("../../../../../assets/images/superadmin/ordericon/phone-credit card-money-finance.svg"),
        show: true,
    },
    {
        id: 5,
        title: "Net Banking",
        value: "Net Banking",
        icon: require("../../../../../assets/images/superadmin/ordericon/online-payment.svg"),
        show: false,
    },
];

const ExternalReference = (props) => {
    const [ref, setRef] = useState("");
    const [refErr, setRefErr] = useState(false);

    const handleDesc = (e) => {
        if (!e.target.value) {
            setRefErr(true);
        } else {
            setRefErr(false);
            setRef(e.target.value);
        }
    };

    const submitCancel = () => {
        props.submitExternal(ref);
    };

    return (
        <React.Fragment>
            <Modal show={true} onHide={props.hideCancel} centered>
                <Modal.Header className="border-0" closeButton>
                    <div className="f18-700">Enter Transaction Reference</div>
                </Modal.Header>
                <Modal.Body>
                    <div className="f18-500 mt-2 mb-4">
                        <Form.Group>
                            <TextField
                                id="reference"
                                variant="outlined"
                                label="Reference"
                                name="reference"
                                className={`w-100  ${refErr ? "enError" : ""}`}
                                onChange={handleDesc}
                                value={ref}
                            />
                        </Form.Group>
                    </div>
                    <div className="mt-4">
                        <div className="row">
                            <div className="col-6">
                                <Button
                                    variant="outline-secondary"
                                    className="btn-md py-2 mb-2"
                                    style={{ width: "90%" }}
                                    onClick={props.hideCancel}
                                >
                                    Cancel
                                </Button>
                            </div>
                            <div className="col-6">
                                <Button
                                    variant="danger"
                                    className="btn-md py-2 mb-2 w-100"
                                    onClick={submitCancel}
                                >
                                    Done
                                </Button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </React.Fragment>
    );
};
